import React, { useState } from 'react';
import {
  HStack,
  Box,
  Icon,
  Text,
  InputGroup,
  InputLeftElement,
  Input,
  InputRightElement,
} from '@chakra-ui/react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { FaSearch, FaEye, FaRegCalendarAlt } from 'react-icons/fa';
import { MdFilterList, MdMenu } from 'react-icons/md';
import { AiFillPrinter } from 'react-icons/ai';
import { useReactToPrint } from 'react-to-print';
import Fielter from './Menu';


interface HeaderProps {
  isMenuEnabled?: boolean;
  isEyeEnabled?: boolean;
  PrintEnabled?: boolean;
  isFilterVisible: boolean;
  onToggleFilter: () => void;
  onView: () => void;
  printRef: React.RefObject<HTMLDivElement>;
  headers: any;
  onHeadersChange: (visibleHeaders: any) => void;
  title: string;
  children?: React.ReactNode;
  searchTerm?: string;
  setSearchTerm?: (searchTerm: any) => void;
}

const Header: React.FC<HeaderProps> = ({
  isMenuEnabled = false,
  isEyeEnabled = false,
  PrintEnabled = false,
  isFilterVisible = false,
  onToggleFilter,
  onView,
  printRef,
  headers,
  onHeadersChange,
  title,
  searchTerm,
  setSearchTerm,
  
}) => {
  const [visibleHeaders, setVisibleHeaders] = useState(headers);

  const handleFilter = (selectedHeaders: Array<{ label: string; key: string }>) => {
    setVisibleHeaders(selectedHeaders);
    onHeadersChange(selectedHeaders);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
      @page {
        size: auto;
        margin: 20mm;
      }
      @media print {
        body * {
          visibility: hidden;
        }
        #print-content, #print-content * {
          visibility: visible;
        }
        #print-content {
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    `,
  });

  return (
    <HStack justify="space-between" border={'2px'} borderColor={'#0f4f6d'} borderRadius={'xl'} p={2}>
      <HStack>
        <Icon boxSize={8} as={IoMdCheckmarkCircleOutline} />
        <Text fontWeight="bold" fontSize="xl">
          {title}
        </Text>
      </HStack>
      <HStack spacing={4} align="center">
        {isFilterVisible && (
          <Box textAlign="center" className="relative transition-all duration-500">
            <InputGroup size="sm">
              <InputLeftElement pointerEvents="none" color="gray.300" fontSize="1.2em">
                <Icon as={FaSearch} boxSize={4} />
              </InputLeftElement>
              <Input 
                  size={"sm"}
                  rounded={"2xl"}
                  placeholder="Pesquise"
                  value={searchTerm}
                  onChange={(e: any) => setSearchTerm && setSearchTerm(e.target.value)}/>
              <InputRightElement>
                <Fielter headers={headers} onFilter={handleFilter}>
                  <Icon as={MdFilterList} boxSize={6} cursor="pointer" />
                </Fielter>
              </InputRightElement>
            </InputGroup>
          </Box>
        )}

        <Box textAlign="center">
          <Icon
            as={MdMenu}
            boxSize={8}
            cursor={isMenuEnabled ? 'pointer' : 'not-allowed'}
            onClick={isMenuEnabled ? onToggleFilter : undefined}
            color={isMenuEnabled ? 'gray.800' : 'gray.300'}
          />
        </Box>
        <Box textAlign="center">
          <Icon
            as={FaEye}
            boxSize={8}
            color={isEyeEnabled ? 'gray.800' : 'gray.300'}
            cursor={isEyeEnabled ? 'pointer' : 'not-allowed'}
            onClick={isEyeEnabled ? onView : undefined}
          />
        </Box>
        <Box textAlign="center">
          <Icon
            as={AiFillPrinter}
            boxSize={8}
            cursor={PrintEnabled ? 'pointer' : 'not-allowed'}
            onClick={PrintEnabled ? handlePrint : undefined}
            color={PrintEnabled ? 'gray.800' : 'gray.300'}
          />
        </Box>
      </HStack>
    </HStack>
  );
};

export default Header;
